module.exports = __webpack_public_path__ + "static/img/skirmisher2.6d62c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/skirmisher2.png
// module id = ZnDx
// module chunks = 0